import _classCallCheck from "D:\\a\\1\\s\\ReactEnergy.Portal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\ReactEnergy.Portal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import Matrix from '../matrix';
import WrapperMatrix2D from '../wrap/WrapperMatrix2D';
import { hypotenuse } from './util';

var SingularValueDecomposition =
/*#__PURE__*/
function () {
  function SingularValueDecomposition(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SingularValueDecomposition);

    value = WrapperMatrix2D.checkMatrix(value);
    var m = value.rows;
    var n = value.columns;
    var _options$computeLeftS = options.computeLeftSingularVectors,
        computeLeftSingularVectors = _options$computeLeftS === void 0 ? true : _options$computeLeftS,
        _options$computeRight = options.computeRightSingularVectors,
        computeRightSingularVectors = _options$computeRight === void 0 ? true : _options$computeRight,
        _options$autoTranspos = options.autoTranspose,
        autoTranspose = _options$autoTranspos === void 0 ? false : _options$autoTranspos;
    var wantu = Boolean(computeLeftSingularVectors);
    var wantv = Boolean(computeRightSingularVectors);
    var swapped = false;
    var a;

    if (m < n) {
      if (!autoTranspose) {
        a = value.clone(); // eslint-disable-next-line no-console

        console.warn('Computing SVD on a matrix with more columns than rows. Consider enabling autoTranspose');
      } else {
        a = value.transpose();
        m = a.rows;
        n = a.columns;
        swapped = true;
        var aux = wantu;
        wantu = wantv;
        wantv = aux;
      }
    } else {
      a = value.clone();
    }

    var nu = Math.min(m, n);
    var ni = Math.min(m + 1, n);
    var s = new Float64Array(ni);
    var U = new Matrix(m, nu);
    var V = new Matrix(n, n);
    var e = new Float64Array(n);
    var work = new Float64Array(m);
    var si = new Float64Array(ni);

    for (var i = 0; i < ni; i++) {
      si[i] = i;
    }

    var nct = Math.min(m - 1, n);
    var nrt = Math.max(0, Math.min(n - 2, m));
    var mrc = Math.max(nct, nrt);

    for (var k = 0; k < mrc; k++) {
      if (k < nct) {
        s[k] = 0;

        for (var _i = k; _i < m; _i++) {
          s[k] = hypotenuse(s[k], a.get(_i, k));
        }

        if (s[k] !== 0) {
          if (a.get(k, k) < 0) {
            s[k] = -s[k];
          }

          for (var _i2 = k; _i2 < m; _i2++) {
            a.set(_i2, k, a.get(_i2, k) / s[k]);
          }

          a.set(k, k, a.get(k, k) + 1);
        }

        s[k] = -s[k];
      }

      for (var j = k + 1; j < n; j++) {
        if (k < nct && s[k] !== 0) {
          var t = 0;

          for (var _i3 = k; _i3 < m; _i3++) {
            t += a.get(_i3, k) * a.get(_i3, j);
          }

          t = -t / a.get(k, k);

          for (var _i4 = k; _i4 < m; _i4++) {
            a.set(_i4, j, a.get(_i4, j) + t * a.get(_i4, k));
          }
        }

        e[j] = a.get(k, j);
      }

      if (wantu && k < nct) {
        for (var _i5 = k; _i5 < m; _i5++) {
          U.set(_i5, k, a.get(_i5, k));
        }
      }

      if (k < nrt) {
        e[k] = 0;

        for (var _i6 = k + 1; _i6 < n; _i6++) {
          e[k] = hypotenuse(e[k], e[_i6]);
        }

        if (e[k] !== 0) {
          if (e[k + 1] < 0) {
            e[k] = 0 - e[k];
          }

          for (var _i7 = k + 1; _i7 < n; _i7++) {
            e[_i7] /= e[k];
          }

          e[k + 1] += 1;
        }

        e[k] = -e[k];

        if (k + 1 < m && e[k] !== 0) {
          for (var _i8 = k + 1; _i8 < m; _i8++) {
            work[_i8] = 0;
          }

          for (var _i9 = k + 1; _i9 < m; _i9++) {
            for (var _j = k + 1; _j < n; _j++) {
              work[_i9] += e[_j] * a.get(_i9, _j);
            }
          }

          for (var _j2 = k + 1; _j2 < n; _j2++) {
            var _t = -e[_j2] / e[k + 1];

            for (var _i10 = k + 1; _i10 < m; _i10++) {
              a.set(_i10, _j2, a.get(_i10, _j2) + _t * work[_i10]);
            }
          }
        }

        if (wantv) {
          for (var _i11 = k + 1; _i11 < n; _i11++) {
            V.set(_i11, k, e[_i11]);
          }
        }
      }
    }

    var p = Math.min(n, m + 1);

    if (nct < n) {
      s[nct] = a.get(nct, nct);
    }

    if (m < p) {
      s[p - 1] = 0;
    }

    if (nrt + 1 < p) {
      e[nrt] = a.get(nrt, p - 1);
    }

    e[p - 1] = 0;

    if (wantu) {
      for (var _j3 = nct; _j3 < nu; _j3++) {
        for (var _i12 = 0; _i12 < m; _i12++) {
          U.set(_i12, _j3, 0);
        }

        U.set(_j3, _j3, 1);
      }

      for (var _k = nct - 1; _k >= 0; _k--) {
        if (s[_k] !== 0) {
          for (var _j4 = _k + 1; _j4 < nu; _j4++) {
            var _t2 = 0;

            for (var _i13 = _k; _i13 < m; _i13++) {
              _t2 += U.get(_i13, _k) * U.get(_i13, _j4);
            }

            _t2 = -_t2 / U.get(_k, _k);

            for (var _i14 = _k; _i14 < m; _i14++) {
              U.set(_i14, _j4, U.get(_i14, _j4) + _t2 * U.get(_i14, _k));
            }
          }

          for (var _i15 = _k; _i15 < m; _i15++) {
            U.set(_i15, _k, -U.get(_i15, _k));
          }

          U.set(_k, _k, 1 + U.get(_k, _k));

          for (var _i16 = 0; _i16 < _k - 1; _i16++) {
            U.set(_i16, _k, 0);
          }
        } else {
          for (var _i17 = 0; _i17 < m; _i17++) {
            U.set(_i17, _k, 0);
          }

          U.set(_k, _k, 1);
        }
      }
    }

    if (wantv) {
      for (var _k2 = n - 1; _k2 >= 0; _k2--) {
        if (_k2 < nrt && e[_k2] !== 0) {
          for (var _j5 = _k2 + 1; _j5 < n; _j5++) {
            var _t3 = 0;

            for (var _i18 = _k2 + 1; _i18 < n; _i18++) {
              _t3 += V.get(_i18, _k2) * V.get(_i18, _j5);
            }

            _t3 = -_t3 / V.get(_k2 + 1, _k2);

            for (var _i19 = _k2 + 1; _i19 < n; _i19++) {
              V.set(_i19, _j5, V.get(_i19, _j5) + _t3 * V.get(_i19, _k2));
            }
          }
        }

        for (var _i20 = 0; _i20 < n; _i20++) {
          V.set(_i20, _k2, 0);
        }

        V.set(_k2, _k2, 1);
      }
    }

    var pp = p - 1;
    var iter = 0;
    var eps = Number.EPSILON;

    while (p > 0) {
      var _k3 = void 0,
          kase = void 0;

      for (_k3 = p - 2; _k3 >= -1; _k3--) {
        if (_k3 === -1) {
          break;
        }

        var alpha = Number.MIN_VALUE + eps * Math.abs(s[_k3] + Math.abs(s[_k3 + 1]));

        if (Math.abs(e[_k3]) <= alpha || Number.isNaN(e[_k3])) {
          e[_k3] = 0;
          break;
        }
      }

      if (_k3 === p - 2) {
        kase = 4;
      } else {
        var ks = void 0;

        for (ks = p - 1; ks >= _k3; ks--) {
          if (ks === _k3) {
            break;
          }

          var _t4 = (ks !== p ? Math.abs(e[ks]) : 0) + (ks !== _k3 + 1 ? Math.abs(e[ks - 1]) : 0);

          if (Math.abs(s[ks]) <= eps * _t4) {
            s[ks] = 0;
            break;
          }
        }

        if (ks === _k3) {
          kase = 3;
        } else if (ks === p - 1) {
          kase = 1;
        } else {
          kase = 2;
          _k3 = ks;
        }
      }

      _k3++;

      switch (kase) {
        case 1:
          {
            var f = e[p - 2];
            e[p - 2] = 0;

            for (var _j6 = p - 2; _j6 >= _k3; _j6--) {
              var _t5 = hypotenuse(s[_j6], f);

              var cs = s[_j6] / _t5;
              var sn = f / _t5;
              s[_j6] = _t5;

              if (_j6 !== _k3) {
                f = -sn * e[_j6 - 1];
                e[_j6 - 1] = cs * e[_j6 - 1];
              }

              if (wantv) {
                for (var _i21 = 0; _i21 < n; _i21++) {
                  _t5 = cs * V.get(_i21, _j6) + sn * V.get(_i21, p - 1);
                  V.set(_i21, p - 1, -sn * V.get(_i21, _j6) + cs * V.get(_i21, p - 1));
                  V.set(_i21, _j6, _t5);
                }
              }
            }

            break;
          }

        case 2:
          {
            var _f = e[_k3 - 1];
            e[_k3 - 1] = 0;

            for (var _j7 = _k3; _j7 < p; _j7++) {
              var _t6 = hypotenuse(s[_j7], _f);

              var _cs = s[_j7] / _t6;

              var _sn = _f / _t6;

              s[_j7] = _t6;
              _f = -_sn * e[_j7];
              e[_j7] = _cs * e[_j7];

              if (wantu) {
                for (var _i22 = 0; _i22 < m; _i22++) {
                  _t6 = _cs * U.get(_i22, _j7) + _sn * U.get(_i22, _k3 - 1);
                  U.set(_i22, _k3 - 1, -_sn * U.get(_i22, _j7) + _cs * U.get(_i22, _k3 - 1));
                  U.set(_i22, _j7, _t6);
                }
              }
            }

            break;
          }

        case 3:
          {
            var scale = Math.max(Math.abs(s[p - 1]), Math.abs(s[p - 2]), Math.abs(e[p - 2]), Math.abs(s[_k3]), Math.abs(e[_k3]));
            var sp = s[p - 1] / scale;
            var spm1 = s[p - 2] / scale;
            var epm1 = e[p - 2] / scale;
            var sk = s[_k3] / scale;
            var ek = e[_k3] / scale;
            var b = ((spm1 + sp) * (spm1 - sp) + epm1 * epm1) / 2;
            var c = sp * epm1 * (sp * epm1);
            var shift = 0;

            if (b !== 0 || c !== 0) {
              if (b < 0) {
                shift = 0 - Math.sqrt(b * b + c);
              } else {
                shift = Math.sqrt(b * b + c);
              }

              shift = c / (b + shift);
            }

            var _f2 = (sk + sp) * (sk - sp) + shift;

            var g = sk * ek;

            for (var _j8 = _k3; _j8 < p - 1; _j8++) {
              var _t7 = hypotenuse(_f2, g);

              if (_t7 === 0) _t7 = Number.MIN_VALUE;

              var _cs2 = _f2 / _t7;

              var _sn2 = g / _t7;

              if (_j8 !== _k3) {
                e[_j8 - 1] = _t7;
              }

              _f2 = _cs2 * s[_j8] + _sn2 * e[_j8];
              e[_j8] = _cs2 * e[_j8] - _sn2 * s[_j8];
              g = _sn2 * s[_j8 + 1];
              s[_j8 + 1] = _cs2 * s[_j8 + 1];

              if (wantv) {
                for (var _i23 = 0; _i23 < n; _i23++) {
                  _t7 = _cs2 * V.get(_i23, _j8) + _sn2 * V.get(_i23, _j8 + 1);
                  V.set(_i23, _j8 + 1, -_sn2 * V.get(_i23, _j8) + _cs2 * V.get(_i23, _j8 + 1));
                  V.set(_i23, _j8, _t7);
                }
              }

              _t7 = hypotenuse(_f2, g);
              if (_t7 === 0) _t7 = Number.MIN_VALUE;
              _cs2 = _f2 / _t7;
              _sn2 = g / _t7;
              s[_j8] = _t7;
              _f2 = _cs2 * e[_j8] + _sn2 * s[_j8 + 1];
              s[_j8 + 1] = -_sn2 * e[_j8] + _cs2 * s[_j8 + 1];
              g = _sn2 * e[_j8 + 1];
              e[_j8 + 1] = _cs2 * e[_j8 + 1];

              if (wantu && _j8 < m - 1) {
                for (var _i24 = 0; _i24 < m; _i24++) {
                  _t7 = _cs2 * U.get(_i24, _j8) + _sn2 * U.get(_i24, _j8 + 1);
                  U.set(_i24, _j8 + 1, -_sn2 * U.get(_i24, _j8) + _cs2 * U.get(_i24, _j8 + 1));
                  U.set(_i24, _j8, _t7);
                }
              }
            }

            e[p - 2] = _f2;
            iter = iter + 1;
            break;
          }

        case 4:
          {
            if (s[_k3] <= 0) {
              s[_k3] = s[_k3] < 0 ? -s[_k3] : 0;

              if (wantv) {
                for (var _i25 = 0; _i25 <= pp; _i25++) {
                  V.set(_i25, _k3, -V.get(_i25, _k3));
                }
              }
            }

            while (_k3 < pp) {
              if (s[_k3] >= s[_k3 + 1]) {
                break;
              }

              var _t8 = s[_k3];
              s[_k3] = s[_k3 + 1];
              s[_k3 + 1] = _t8;

              if (wantv && _k3 < n - 1) {
                for (var _i26 = 0; _i26 < n; _i26++) {
                  _t8 = V.get(_i26, _k3 + 1);
                  V.set(_i26, _k3 + 1, V.get(_i26, _k3));
                  V.set(_i26, _k3, _t8);
                }
              }

              if (wantu && _k3 < m - 1) {
                for (var _i27 = 0; _i27 < m; _i27++) {
                  _t8 = U.get(_i27, _k3 + 1);
                  U.set(_i27, _k3 + 1, U.get(_i27, _k3));
                  U.set(_i27, _k3, _t8);
                }
              }

              _k3++;
            }

            iter = 0;
            p--;
            break;
          }
        // no default
      }
    }

    if (swapped) {
      var tmp = V;
      V = U;
      U = tmp;
    }

    this.m = m;
    this.n = n;
    this.s = s;
    this.U = U;
    this.V = V;
  }

  _createClass(SingularValueDecomposition, [{
    key: "solve",
    value: function solve(value) {
      var Y = value;
      var e = this.threshold;
      var scols = this.s.length;
      var Ls = Matrix.zeros(scols, scols);

      for (var i = 0; i < scols; i++) {
        if (Math.abs(this.s[i]) <= e) {
          Ls.set(i, i, 0);
        } else {
          Ls.set(i, i, 1 / this.s[i]);
        }
      }

      var U = this.U;
      var V = this.rightSingularVectors;
      var VL = V.mmul(Ls);
      var vrows = V.rows;
      var urows = U.rows;
      var VLU = Matrix.zeros(vrows, urows);

      for (var _i28 = 0; _i28 < vrows; _i28++) {
        for (var j = 0; j < urows; j++) {
          var sum = 0;

          for (var k = 0; k < scols; k++) {
            sum += VL.get(_i28, k) * U.get(j, k);
          }

          VLU.set(_i28, j, sum);
        }
      }

      return VLU.mmul(Y);
    }
  }, {
    key: "solveForDiagonal",
    value: function solveForDiagonal(value) {
      return this.solve(Matrix.diag(value));
    }
  }, {
    key: "inverse",
    value: function inverse() {
      var V = this.V;
      var e = this.threshold;
      var vrows = V.rows;
      var vcols = V.columns;
      var X = new Matrix(vrows, this.s.length);

      for (var i = 0; i < vrows; i++) {
        for (var j = 0; j < vcols; j++) {
          if (Math.abs(this.s[j]) > e) {
            X.set(i, j, V.get(i, j) / this.s[j]);
          }
        }
      }

      var U = this.U;
      var urows = U.rows;
      var ucols = U.columns;
      var Y = new Matrix(vrows, urows);

      for (var _i29 = 0; _i29 < vrows; _i29++) {
        for (var _j9 = 0; _j9 < urows; _j9++) {
          var sum = 0;

          for (var k = 0; k < ucols; k++) {
            sum += X.get(_i29, k) * U.get(_j9, k);
          }

          Y.set(_i29, _j9, sum);
        }
      }

      return Y;
    }
  }, {
    key: "condition",
    get: function get() {
      return this.s[0] / this.s[Math.min(this.m, this.n) - 1];
    }
  }, {
    key: "norm2",
    get: function get() {
      return this.s[0];
    }
  }, {
    key: "rank",
    get: function get() {
      var tol = Math.max(this.m, this.n) * this.s[0] * Number.EPSILON;
      var r = 0;
      var s = this.s;

      for (var i = 0, ii = s.length; i < ii; i++) {
        if (s[i] > tol) {
          r++;
        }
      }

      return r;
    }
  }, {
    key: "diagonal",
    get: function get() {
      return Array.from(this.s);
    }
  }, {
    key: "threshold",
    get: function get() {
      return Number.EPSILON / 2 * Math.max(this.m, this.n) * this.s[0];
    }
  }, {
    key: "leftSingularVectors",
    get: function get() {
      return this.U;
    }
  }, {
    key: "rightSingularVectors",
    get: function get() {
      return this.V;
    }
  }, {
    key: "diagonalMatrix",
    get: function get() {
      return Matrix.diag(this.s);
    }
  }]);

  return SingularValueDecomposition;
}();

export { SingularValueDecomposition as default };